<template>
  <div class="accidental-renewal">
    <h2 class="h3 mb-2"><b>{{ $t('purchases.accidental_renewal.worried_about_an_accidental_renewal') }}</b></h2>
    <i18n-t keypath="purchases.accidental_renewal.we_ll_send_you_a_reminder_on" tag="p" class="mb-4" scope="global">
      <template #date><b class="text-brand-yellow">{{ reminderOn }}</b></template>
    </i18n-t>

    <p class="text-muted mb-2">{{ $t('purchases.accidental_renewal.how_that_looks') }}</p>
    <div class="card">
      <div class="card-body">
        <div class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons accidental-renewal__icon">bolt</span>
          <div>
            <p class="mb-0"><b>{{ $t('purchases.accidental_renewal.keep_your_pro_access_now') }}</b></p>
            <p class="text-muted mb-0">{{ $t('purchases.accidental_renewal.continue_using_pro_maps_and_features') }}</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3 mb-3">
          <span class="material-icons accidental-renewal__icon">event</span>
          <div>
            <p class="mb-0"><b>{{ reminderOn }}</b></p>
            <p class="text-muted mb-0">{{ $t('purchases.accidental_renewal.receive_reminder') }}</p>
          </div>
        </div>
        <div class="d-flex align-items-start gap-3">
          <span class="material-icons accidental-renewal__icon">help_outline</span>
          <div>
            <p class="mb-0"><b>{{ $t('purchases.accidental_renewal.make_your_decision_then') }}</b></p>
            <p class="text-muted mb-0">{{ $t('purchases.accidental_renewal.you_can_choose_to_cancel_or') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{ reminderOn: string }>();
</script>

<style scoped lang="scss">
.accidental-renewal {
  &__icon {
    color: var(--text-muted, #b2b2b2);
  }
}

.text-brand-yellow {
  color: #caa300;
}
</style>
